import React from 'react';

import { withRouter } from 'react-router';
import { FormattedMessage } from 'react-intl';
import { isEqual, cloneDeep } from 'lodash';

import reduxStore from './../../reduxStore';
import utils from './../../utils/utilities';

import EditName from './../EditThirdParty/components/EditName';
import EditEntityId from './../EditThirdParty/components/EditEntityId';
import EditEntityDuns from './../EditThirdParty/components/EditEntityDuns';
import EditEntityExperian from './../EditThirdParty/components/EditEntityExperian';
import EditEntityUrl from './../EditThirdParty/components/EditEntityUrl';
import EditCategories from './../EditThirdParty/components/EditCategories';
import EditActivation from './../EditThirdParty/components/EditActivation';

import CreateNewEntityButtons from './components/CreateNewEntityButtons.jsx';
import PreviewEntity from './EditEntitySearchParameters/PreviewEntity.jsx';

import actions from './CreateNewEntity.actions';
import popupActions from './../../reusable/MessagePopup/redux/MessagePopup.actions';
import headerActions from './../../reusable/Header/Header.actions';

import withStore from './../../reusable/Wrappers/StoreWrapper/StoreWrapper.jsx';
import Spinnable from './../../reusable/Wrappers/SpinnerWrapper/SpinnerWrapper.jsx';

import xhr from './../../utils/xhr';

import { POST, POPUP_LIFETIME } from './../../constants';

class CreateNewEntity extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isAboutSectionOpened: true,
            isSearchSectionOpened: true,
            isSearchSectionDisabled: true,
            isEmptyTable: true,
            previewTableRequestPayload: null,
            showDialogToggle: false,
            isSavingEntity: false,
            tempCategories: []
        };

        this.previewEntityUrls = {
            tableBaseUrl:      '/api/entities/preview',
            previewArticleUrl: '/api/entities/preview-article/'
        };

        this.requestMethods = {
            tableBaseUrl:      POST,
            previewArticleUrl: POST
        };

        this.noCategories = [];

        this.toggleAboutSection = this.toggleAboutSection.bind(this);
        this.toggleSearchParametersSection = this.toggleSearchParametersSection.bind(this);
        this.setSearchSectionOverlay = this.setSearchSectionOverlay.bind(this);
        this.onRefreshTableHandler = this.onRefreshTableHandler.bind(this);
        this.updateCompanyData = this.updateCompanyData.bind(this);
        this.validateFields = this.validateFields.bind(this);
        this.saveCompanyData = this.saveCompanyData.bind(this);
        this.goBack = this.goBack.bind(this);
    }

    componentWillMount() {
        headerActions.updateHeader('createNewEntity');

        if (!this.props.store.thirdPartyPages.isReturningFromArticlePage) {
            let clearedCompanyData = {
                active:             false,
                categoryIds:        [],
                tempCategories:     [],
                companyNames:       [],
                companyTitle:       '',
                contextKeywords:    [],
                dunsNumber:         '',
                entityUrl:          '',
                exclusionKeywords:  [],
                experianBusinessId: '',
                filter:             '',
                id:                 '',
                uniqueThirdPartyId: '',
                personSearch:     false,
                companySearch:    false
            };

            actions.setCompanyData(clearedCompanyData);
            this.setState({ previewTableRequestPayload: clearedCompanyData });
        } else {

            // If the user returns from the articles page then restore the previous data.
            this.setState({
                isEmptyTable: false,
                previewTableRequestPayload: this.props.store.thirdPartyPages.companyData
            });
            this.setSearchSectionOverlay(this.props.store.thirdPartyPages.companyData);
            actions.setReturnFromArticlePageFlag(false);
        }
    }

    componentWillUnmount() {
        let nextPage = this.props.router.location.pathname;

        if (nextPage.indexOf('/view-article') === -1) {
            actions.setCompanyData(null);
        }
        // Clear the previewCompany redux state, to ensure other pages are not using this info
        reduxStore.dispatch({type: 'PREVIEW_PARAMS_CLEAR', payload: reduxStore.getState().user.preferences.previewCompany});
    }

    componentWillReceiveProps(nextProps) {
        let nextCompanyData = nextProps.store.thirdPartyPages.companyData,
            currentCompanyData = this.props.store.thirdPartyPages.companyData;

        currentCompanyData  = currentCompanyData ? currentCompanyData : {};

        this.setSearchSectionOverlay(nextCompanyData);

        // Only update the preview table payload when the keywords or name and variants have changed.
        // This prevents the table from uselessly doing lots of refreshes.
        if (!isEqual(nextCompanyData.companyNames, currentCompanyData.companyNames) ||
            !isEqual(nextCompanyData.contextKeywords, currentCompanyData.contextKeywords) ||
            !isEqual(nextCompanyData.exclusionKeywords, currentCompanyData.exclusionKeywords)) {
                this.setState({ previewTableRequestPayload: nextCompanyData });
        }
    }

    toggleAboutSection() {
        this.setState({
            isAboutSectionOpened: !this.state.isAboutSectionOpened,
            togglePanelPositionUpdate: !this.state.togglePanelPositionUpdate,
            toggleDialogPositionUpdate: !this.state.toggleDialogPositionUpdate
        });
    }

    toggleSearchParametersSection() {
        this.setState(... this.state, {
            isSearchSectionOpened: !this.state.isSearchSectionOpened,
            togglePanelPositionUpdate: !this.state.togglePanelPositionUpdate,
            toggleDialogPositionUpdate: !this.state.toggleDialogPositionUpdate
        });
    }

    setSearchSectionOverlay(companyData) {
        this.setState({ isSearchSectionDisabled: companyData.companyNames.length === 0 });
    }

    updateCompanyData(property, value) {
        let newCompanyData = cloneDeep(this.props.store.thirdPartyPages.companyData);
        newCompanyData[property] = value;

        if (property === 'companyTitle' && newCompanyData.companyNames.length === 0) {
            newCompanyData.companyNames.push(value);
            this.setState({ showDialogToggle: !this.state.showDialogToggle }); // Show Refresh dialog
        }

        actions.setCompanyData(newCompanyData);
    }

    onRefreshTableHandler() {
        this.setState({ isEmptyTable: false });
    }

    validateFields(skipDunsValidation = false) {
        let isValidTitle    = this.editName.validateTitle(),
            isValidDuns     = skipDunsValidation ? true : this.editDuns.validateDuns(),
            isValidExperian = this.editExperian.validateExperianFormat();

        return isValidTitle && isValidDuns && isValidExperian;
    }

    saveCompanyData() {
        let companyData = cloneDeep(this.props.store.thirdPartyPages.companyData),
            skipDunsValidation = false;

        // Autocomplete DUNS number with 00-000-0000 if it's empty.
        if (companyData.dunsNumber.length === 0) {
            companyData.dunsNumber = '00-000-0000';
            skipDunsValidation = true;
        }

        if (this.validateFields(skipDunsValidation)) {
            this.setState({ isSavingEntity: true });
            actions.saveCompany(companyData).then((response) => {
                this.setState({ isEmptyTable: false,  isSavingEntity: false });
                this.props.router.push('/manage-third-parties');

                popupActions.setMessages({
                    popupTitle: null,
                    messages: [
                        {
                            messageId: 'Entities_CoreFunctionality_UIText_createNewEntity.successMessage',
                            values: {
                                entityName: companyData.companyNames[0]
                            },
                            messageType: 'success'
                        }
                    ]
                });

                // Hide the message after 5 seconds.
                setTimeout(popupActions.removeMessage, POPUP_LIFETIME);

                window.scrollTo(0, 0);
            }).catch((error) => {
                this.setState({ isSavingEntity: false });
                switch (error.status) {
                    case 403:
                        popupActions.setMessages({
                            popupTitle: null,
                            messages:   [
                                {
                                    messageId:   'Entities_Review_Error_SUBSCRIPTION_CAP_EXCEEDED',
                                    messageType: 'system-error'
                                }
                            ]
                        });
                        // Hide the message after 5 seconds.
                        setTimeout(popupActions.removeMessage, POPUP_LIFETIME);
                        break;
                    case 400:
                        popupActions.setMessages({
                            popupTitle: null,
                            messages:   [
                                {
                                    messageId:   'General_CoreFunctionality_Error_general.saveError',
                                    messageType: 'system-error'
                                }
                            ]
                        });
                        // Hide the message after 5 seconds.
                        setTimeout(popupActions.removeMessage, POPUP_LIFETIME);
                        break;
                    default:
                        utils.logError(error, 'CreateNewEntity.saveCompanyData():');
                        xhr.handleAllErrors(error);
                }
            });
        }
    }

    goBack() {
        this.props.router.push('/manage-third-parties');
    }

    render() {
        let companyData = this.props.store.thirdPartyPages.companyData;

        let SaveCancelButtons = <CreateNewEntityButtons
            saveCompanyData={this.saveCompanyData}
            goBack={this.goBack}
            disabled={this.state.isSavingEntity}/>;

        return (
            <div className="create-new-entity">

                <div className="create-new-entity__controls">
                    {SaveCancelButtons}
                </div>

                <div className="edit-third-party__about">
                    <a className="edit-third-party__open-section-link" onClick={this.toggleAboutSection}>
                        <span className={this.state.isAboutSectionOpened ? 'la-TriangleDown' : 'la-TriangleRight'}>
                        </span>
                        <h2><FormattedMessage id="Entities_Edit_UIText_editThirdParty.aboutSectionTitle" /></h2>
                    </a>

                    <div className={this.state.isAboutSectionOpened ? '' : ' hidden'}>

                        <form className='edit-third-party__about__form'>

                            <div className="create-new-entity__form-info">
                                <span>
                                    <FormattedMessage id="Entities_Edit_UIText_editThirdParty.aboutSectionDescription"/>
                                </span>
                                <span><span className="required-field-star" />
                                    = <span>
                                        <FormattedMessage id="General_CoreFunctionality_UIText_general.required" />
                                    </span>
                                </span>
                            </div>

                            <div className='edit-third-party__about__container'>
                                <div className="edit-third-party__about__left">
                                    <EditName entityId=''
                                              companyTitle={companyData ? companyData.companyTitle : ''}
                                              ref={(component) => {this.editName = component;}}
                                              onBlur={this.updateCompanyData}
                                              hideEntityProfileLink={true}
                                              isRequiredField={true} />
                                    <EditEntityId uniqueThirdPartyId={companyData ? companyData.uniqueThirdPartyId : ''}
                                                  onBlur={this.updateCompanyData} />
                                    <EditEntityDuns dunsNumber={companyData ? companyData.dunsNumber : ''}
                                                    ref={(component) => {this.editDuns = component;}}
                                                    onBlur={this.updateCompanyData}
                                                    isRequiredField={true} />
                                    <EditEntityExperian experianBusinessId={companyData ?
                                                                                companyData.experianBusinessId : ''}
                                                        ref={(component) => {this.editExperian = component;}}
                                                        entityName={companyData ? companyData.companyTitle : null}
                                                        onBlur={this.updateCompanyData}
                                                        hideExperianCheckButton={false}
                                                        isRequiredField={true} />
                                </div>

                                <div className="edit-third-party__about__right">
                                    <EditEntityUrl entityUrl={companyData ? companyData.entityUrl : ''}
                                                   onBlur={this.updateCompanyData}/>

                                    <EditCategories data={companyData ? companyData.categoryIds : this.noCategories}
                                                    handleChange={this.updateCompanyData}/>

                                    <EditActivation data={companyData ? companyData.active : false}
                                                    handleChange={this.updateCompanyData}
                                                    enableDeactivateWarning={false}/>
                                </div>
                            </div>
                        </form>

                    </div>
                </div>

                <div className="edit-third-party__search-parameters">
                    <a className="edit-third-party__open-section-link" onClick={this.toggleSearchParametersSection}>
                        <span className={this.state.isSearchSectionOpened ? 'la-TriangleDown' : 'la-TriangleRight'}>
                        </span>
                        <h2><FormattedMessage id="Entities_Edit_UIText_editThirdParty.searchSectionTitle" /></h2>
                    </a>

                    <div className={'edit-third-party__search-parameters__content' +
                                        (this.state.isSearchSectionOpened ? '' : ' hidden') +
                                        (this.state.isSearchSectionDisabled ? ' disabled' : '')}>
                        <div className="edit-third-party__search-parameters__overlay"></div>
                        <div className={this.state.isAboutSectionOpened ? '' : 'refresh-dialog__popup__fixed'}>
                        <PreviewEntity actions={actions}
                                       updateCompanyData={this.updateCompanyData}
                                       isPanelAlwaysVisible={true}
                                       isSearchSectionOpened={this.state.isSearchSectionOpened}
                                       togglePanelPositionUpdate={this.state.togglePanelPositionUpdate}
                                       toggleDialogPositionUpdate={this.state.toggleDialogPositionUpdate}
                                       panelCustomContent={SaveCancelButtons}
                                       companyData={companyData}
                                       tableBaseUrl={this.previewEntityUrls.tableBaseUrl}
                                       previewArticleUrl={this.previewEntityUrls.previewArticleUrl}
                                       previewArticleRequestPayload={companyData}
                                       previewTableRequestPayload={this.state.previewTableRequestPayload}
                                       preventTableScrollToTop={true}
                                       requestMethods={this.requestMethods}
                                       initializeEmptyTable={this.state.isEmptyTable}
                                       onRefreshTableHandler={this.onRefreshTableHandler}
                                       showDialogToggle={this.state.showDialogToggle} />
                    </div>
                    </div>
                </div>

            </div>
        );

    }

}

export default Spinnable(withRouter(
    withStore(CreateNewEntity, ['thirdPartyPages'])
));


// WEBPACK FOOTER //
// ./src/scripts/pages/CreateNewEntity/CreateNewEntity.jsx